// GodMode.jsx -- floating role-switcher panel for demo/local use
// ASCII only. var only. Max 120 lines.
import { useState } from 'react';

var USERS = [
  { email: 'aaron@sprintmode.co',   name: 'Aaron Hall',      role: 'CAIO' },
  { email: 'hugh@sprintmode.co',    name: 'Hugh Myers',      role: 'CEO' },
  { email: 'clayton@sprintmode.co', name: 'Clayton Bryan',   role: 'Capital' },
  { email: 'dani@sprintmode.co',    name: 'Dani Reyes',      role: 'Studios' },
  { email: 'eugenio@sprintmode.co', name: 'Eugenio Ortiz',   role: 'Engineering' },
  { email: 'nikola@sprintmode.co',  name: 'Nikola Petrovic', role: 'Platform Ops' },
  { email: 'elle@sprintmode.co',    name: 'Elle Martin',     role: 'AP/AR' },
];

function avatarColor(role) {
  if (role === 'CAIO' || role === 'CEO' || role === 'Capital') return '#2563EB';
  if (role === 'Studios' || role === 'Engineering') return '#16A34A';
  return '#64748B';
}

function initials(name) {
  var parts = name.split(' ');
  return (parts[0][0] + (parts[1] ? parts[1][0] : '')).toUpperCase();
}

function isVisible() {
  return (
    window.location.hostname === 'localhost' ||
    localStorage.getItem('hub_god_mode') === 'true'
  );
}

export default function GodMode() {
  var _open = useState(false);
  var open = _open[0]; var setOpen = _open[1];

  if (!isVisible()) return null;

  var current = localStorage.getItem('hub_impersonate') || '';

  function impersonate(email) {
    localStorage.setItem('hub_impersonate', email);
    window.location.reload();
  }

  function allAccess() {
    localStorage.setItem('hub_impersonate', 'aaron@sprintmode.co');
    localStorage.setItem('hub_all_access', 'true');
    window.location.reload();
  }

  function clearImpersonate() {
    localStorage.removeItem('hub_impersonate');
    localStorage.removeItem('hub_all_access');
    window.location.reload();
  }

  return (
    <div style={{ position: 'fixed', bottom: 20, right: 20, zIndex: 9999, fontFamily: 'sans-serif' }}>
      {open && (
        <div style={{
          width: 240, background: '#fff', borderRadius: 12, border: '1px solid #E2E8F0',
          boxShadow: '0 8px 32px rgba(0,0,0,0.14)', marginBottom: 8, overflow: 'hidden'
        }}>
          <div style={{ padding: '10px 14px', borderBottom: '1px solid #E2E8F0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', color: '#475569' }}>God Mode</span>
            <button onClick={function() { setOpen(false); }} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 15, color: '#94A3B8', lineHeight: 1 }}>x</button>
          </div>
          <div style={{ padding: '6px 0' }}>
            {USERS.map(function(u) {
              var active = current === u.email;
              return (
                <div key={u.email} onClick={function() { impersonate(u.email); }} style={{
                  display: 'flex', alignItems: 'center', gap: 10, padding: '7px 14px',
                  cursor: 'pointer', borderLeft: active ? '3px solid #2563EB' : '3px solid transparent',
                  background: active ? '#EFF6FF' : 'transparent'
                }}>
                  <div style={{
                    width: 28, height: 28, borderRadius: '50%', background: avatarColor(u.role),
                    color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 10, fontWeight: 700, flexShrink: 0
                  }}>{initials(u.name)}</div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 12, fontWeight: 600, color: '#0F172A', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{u.name}</div>
                    <div style={{ fontSize: 10, color: '#64748B' }}>{u.role}</div>
                  </div>
                </div>
              );
            })}
          </div>
          <div style={{ borderTop: '1px solid #E2E8F0', padding: '8px 14px', display: 'flex', flexDirection: 'column', gap: 6 }}>
            <button onClick={allAccess} style={{
              padding: '6px 0', border: 'none', borderRadius: 6, background: '#0F172A',
              color: '#fff', fontSize: 11, fontWeight: 700, cursor: 'pointer', letterSpacing: 0.5
            }}>All Access (Aaron)</button>
            <button onClick={clearImpersonate} style={{
              background: 'none', border: 'none', cursor: 'pointer', fontSize: 11,
              color: '#94A3B8', textDecoration: 'underline', padding: 0, textAlign: 'left'
            }}>Clear impersonation</button>
          </div>
        </div>
      )}
      <button onClick={function() { setOpen(!open); }} style={{
        display: 'flex', alignItems: 'center', gap: 6, padding: open ? '7px 14px' : '7px 10px',
        background: '#0F172A', color: '#fff', border: 'none', borderRadius: 20,
        cursor: 'pointer', fontSize: 11, fontWeight: 700, boxShadow: '0 2px 8px rgba(0,0,0,0.25)'
      }}>
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
          <ellipse cx="12" cy="12" rx="10" ry="6"/><circle cx="12" cy="12" r="3"/>
        </svg>
        {open && <span>God Mode</span>}
      </button>
    </div>
  );
}
